import React from "react";
import Footer from "./Footer";
import "../css/contactus.scss";
import Header from "./Header";

function Contact() {
  return (
    <div className="contact">
      <Header />
      <div className="section section--full-width " style={{}}>
        <div className="section-body trim-margins text-center mx-auto max-w-[--content-width]">
          <h1
            data-animation="heading"
            data-animation-group="template--25477055578433__rich_text_z3VQp3"
            className="h1 my-2"
          >
            Contact Petoutlet: We're Here to Help
          </h1>
          <div
            data-animation="paragraph"
            data-animation-group="template--25477055578433__rich_text_z3VQp3"
            className="my-4  prose max-w-none"
          >
            <p>
              <strong>Got Questions? We Want to Hear From You!</strong>
            </p>
            <p>
              We're always standing by in case you have questions or need
              pointers on our products. Whether you need help choosing the right
              pet kennel or are looking for the perfect bed for your&nbsp;older
              cat, we're here to help!
            </p>
            <p>
              Your feedback helps us improve. Please don't hesitate to share
              your thoughts, questions, stories, or concerns with us. If you're
              ever unsatisfied with a product, we'd like the chance to help.
            </p>
          </div>
        </div>
      </div>
      <div
        className="
      multicolumn__item flex flex-col trim-margins snap-center snap-always
      text-center items-center"
      >
        <div className="h4">Contact Us</div>
        <div className="prose  mt-2">
          <p>
            Our Customer Care Team is available Monday through Friday, from
            9am to 5pm HKT, excluding Hong Kong public holidays.
            <br />
            <br />
            HANG LOK BUILDING WING LOK STREET 130 CENTRAL AND WESTERN DISTRICT
            HONG KONG
          </p>
          <p>
            <a
              href="mailto:audit@petoutlet.work"
              title="mailto:audit@petoutlet.work"
            >
              audit@petoutlet.work
            </a>
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Contact;
